import type { IndicatorDef } from './types'

/**
 * klinecharts addresses an indicator instance by (paneId, name) only, so each
 * version gets its own engine name: the bare id for the untouched builtin v1
 * ('RSI'), `<id>@<version>` for ours ('RSI@2'). Duplicate instances get a
 * `#k` clone suffix minted by the Workbench ('RSI@2#2').
 */
export function engineBase(def: Pick<IndicatorDef, 'id' | 'version' | 'builtin'>): string {
  return def.builtin ? def.id : `${def.id}@${def.version}`
}

const ENGINE_NAME = /^([A-Za-z0-9_]+)(?:@(\d+))?(?:#(\d+))?$/

export function parseEngineName(name: string): { id: string; version: number; clone: number } | null {
  const m = ENGINE_NAME.exec(name)
  if (!m) return null
  return { id: m[1], version: m[2] ? Number(m[2]) : 1, clone: m[3] ? Number(m[3]) : 1 }
}
